/** Nav labels keyed by id — never use the English title as identity in code. */
const dictionary = {
  en: {
    items: {
      dashboard: "Dashboard",
      assessments: "Assessments",
      dataShareInvites: "Data Share Invites",
      helpCenter: "Help Center",
      settings: "Settings",
      logout: "Logout",
    },
  },
  de: {
    items: {
      dashboard: "Dashboard",
      assessments: "Assessments",
      dataShareInvites: "Einladungen zur Datenfreigabe",
      helpCenter: "Hilfezentrum",
      settings: "Einstellungen",
      logout: "Abmelden",
    },
  },
  "fi": {
    "items": {
      "dashboard": "Etusivu",
      "assessments": "Arvioinnit",
      "dataShareInvites": "Tietojen jakopyynnöt",
      "helpCenter": "Ohjekeskus",
      "settings": "Asetukset",
      "logout": "Kirjaudu ulos"
    }
  }
};

export default dictionary;
